module.exports = __webpack_public_path__ + "static/PlutoSansMedium-e251dcd2c772cefc5ab04a94855d1615.ttf";